import '../css/style.scss';
import { UIWHeaderController } from './ui_html/header/UIWHeaderController.ts';
import { UISidebarController } from './ui_html/sidebar/UISidebarController.ts';
import { EntryShared } from '../../shared/scripts/EntryShared.ts';
import { UISingletonScrollController } from '../../shared/scripts/ui_scroll_controller/UISingletonScrollController.ts';
import { EntrySingletonPageShared } from '../EntrySingletonPageShared.ts';
import { ClientUserState } from '../../shared/scripts/ClientUserState.ts';
import { HelplyLoader } from '../../shared/scripts/HelplyLoader.ts';
void init();
async function init() {
    EntryShared.initializeAudio();
    await EntryShared.initializeEntry();
    const headerController = new UIWHeaderController();
    new UISidebarController();
    if (document.querySelector('.content_singleton_page')) new UISingletonScrollController();
    ClientUserState.registerChangeListener(()=>HelplyLoader.init());
    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController);
}
